














































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {
  AnswerServiceTransaction,
  EntityServiceTransaction,
  ServiceTransactionInitState, ServiceTransactionStatus
} from '@/store/service-transaction/service-transaction.types';
import {Action, State} from 'vuex-class';
import {MemberServiceType} from '@/store/member/member.enum';
import BoxTextComponent from '@/components/profile/BoxText.vue';
import {ResponseCode} from '@/class/http';
import {Toast} from '@/store/toast/toast.types';
import {Helper} from '../../../util/helper';
import MainTwoComponents from '@/components/layout/Main-2.vue';
import BgTheme1 from '@/components/bg-theme-1.vue';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';


@Component({
  components: {
    BgTheme1,
    BoxTextComponent
  }
})
export default class InviteDetailComponent extends Vue {

  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_answerServiceTransaction', {namespace: 'serviceTransaction'}) answerServiceTransaction!: (payload: AnswerServiceTransaction) => Promise<void>;

  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
  public lib: Helper = new Helper();
  public listTransactionInvite = [] as EntityServiceTransaction[];
  public serviceTransaction = {} as EntityServiceTransaction;
  public docReady = false;
  public answerService = '';
  public titleService = '';
  public dataService = '';
  public phoneService = '';

  async mounted() {
    await this.Loading(true);
    if (this.serviceTransactionInitState.serviceTransactions[0].id === undefined) {
      await this.$router.push('/invite-notification');
      return;
    }
    this.listTransactionInvite = this.serviceTransactionInitState.serviceTransactions;
    this.serviceTransaction = await this.listTransactionInvite.find((x) => x.id === this.$route.params.id) as EntityServiceTransaction;
    this.dataTraServiceType(this.serviceTransaction);
    this.docReady = true;
    await this.Loading(false);
  }

  timeService(service: EntityServiceTransaction) {
    return `${this.lib.formatTime(service.serviceDate)} น.`
  }

  traServiceType(service: EntityServiceTransaction) {
    if(service.serviceType === MemberServiceType.ServiceReceiver) {
      if (this.loginInfo.id === service.memberId) {
        return 'ให้บริการ';
      } else {
        return 'รับบริการ';
      }
    }else {
      if (this.loginInfo.id === service.memberId) {
        return 'รับบริการ';
      } else {
        return 'ให้บริการ';
      }
    }
  }

  async answer(answer: string) {
    this.answerService = answer;
    this.$bvModal.show('my-modal');
  }

  tarStatus(text: string) {
    switch (text) {
      case ServiceTransactionStatus.Waiting : {
        return 'รอตอบรับ';
      }
      case ServiceTransactionStatus.Confirm : {
        return 'รอดำเนินการ';
      }
      case ServiceTransactionStatus.CodeGenerated : {
        return 'รอดำเนินการ';
      }
      case ServiceTransactionStatus.Done : {
        return 'เสร็จแล้ว';
      }
      case ServiceTransactionStatus.Running : {
        return 'กำลังดำเนินการ';
      }
      case ServiceTransactionStatus.FinalCodeGenerated : {
        return 'กำลังดำเนินการ';
      }
      case ServiceTransactionStatus.Reject : {
        return 'ยกเลิก';
      }
      case ServiceTransactionStatus.Busy : {
        return 'มีคนตอบรับแล้ว';
      }
      case ServiceTransactionStatus.Deny : {
        return 'ปฏิเสธ';
      }
      case ServiceTransactionStatus.Deleted : {
        return 'ยกเลิกอัตโนมัติ';
      }
      default : {
        return text;
      }
    }

  }

  close() {
    this.$bvModal.hide('my-modal');
  }

  async submitAnswerService() {
    await this.Loading(true);
    this.$bvModal.hide('my-modal');
    let answer = {
      id: this.serviceTransaction.id,
      answer: this.answerService
    } as AnswerServiceTransaction;
    let resAnswer = await this.answerServiceTransaction(answer);
    let stats = JSON.parse(JSON.stringify(resAnswer)).data as ResponseCode;
    if (stats.appCode === 20001) {
      this.Toast({
        message: 'ตอบกลับคำเชิญเรียบร้อยแล้ว',
        heading: 'บันทึกข้อมูลสำเร็จ',
        type: 'success',
      });
      await this.Loading(false);
      await this.$router.push('/main');
    } else {
      this.Toast({
        message: 'ตอบกลับคำเชิญเรียบร้อยแล้วไม่สำเร็จ',
        heading: 'บันทึกข้อมูลไม่สำเร็จ',
        type: 'warning',
      });
      await this.Loading(false);
      await this.$router.push('/main');
    }
  }

  dataTraServiceType(service: EntityServiceTransaction) {

    if(service.serviceType === MemberServiceType.ServiceReceiver) {
      if (this.loginInfo.id === service.memberId) {
        this.dataService = `${service.invite.firstName} ${service.invite.lastName}`;
        this.titleService = 'ผู้รับบริการ';
        this.phoneService = service.invite.mobilePhone;
      } else {
        this.titleService = 'ผู้ให้บริการ';
        this.dataService = `${service.member.firstName} ${service.member.lastName}`;
        this.phoneService = service.phone;
      }
    }else {
      if (this.loginInfo.id === service.memberId) {
        this.dataService = `${service.invite.firstName} ${service.invite.lastName}`;
        this.titleService = 'ผู้ให้บริการ';
        this.phoneService = service.invite.mobilePhone;
      } else {
        this.titleService = 'ผู้รับบริการ';
        this.dataService = `${service.member.firstName} ${service.member.lastName}`;
        this.phoneService = service.phone;
      }
    }
  }

}
